import { createFileRoute } from '@tanstack/react-router'

import { BackofficeInsuranceCertificateGeneratorRealEstateSalesAgentsPage } from '../../../../../components/pages/backoffice/insurance-certificate-generator/backoffice-insurance-certificate-generator-real-estate-sales-agents-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute(
  '/bo/contracts/$subscriptionId/insurance-certificate-generator-real-estate-sales-agents',
)({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <BackofficeInsuranceCertificateGeneratorRealEstateSalesAgentsPage />
    </PermissionChecker>
  ),
})
